<div class="content" fxLayout="column" fxLayoutGap="12px"
    [@routeAnimation]="true">
    <div fxLayout="column" fxLayout.sm="column" fxLayoutAlign="start start"
        fxLayoutGap="16px">
        <div fxLayout="row" *ngIf="tableType === 'pending'">
            <button mat-raised-button color="primary"
                [disabled]="!selection.hasValue()" (click)="onProcess()">
                Process selected request(s)
            </button>
        </div>
        <div fxLayout="row" *ngIf="tableType === 'processed'">
            <button mat-raised-button color="primary"
                [disabled]="!selection.hasValue()"
                (click)="onUpdateToCheckIssue()">
                Update Status of Request(s) to Check Issue
            </button>
        </div>
        <div fxLayout="row">
            <mat-form-field>
                <mat-select [value]='selectedPaymentValue' placeholder="Filter
                    requests by Payment Option"
                    (selectionChange)="onChangePaymentOption($event.value)">
                    <mat-option value="">ALL</mat-option>
                    <mat-option value="CHECK">CHECK</mat-option>
                    <mat-option value="CREDIT">CREDIT</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="filter">
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)"
                placeholder="Search">
        </mat-form-field>
    </div>
    <div fxLayout="column" class="mat-elevation-z8 table-container">

        <mat-table class="mat-elevation-z8 table-container" #table
            [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ?
                        masterToggle($event.checked) : null"
                        [checked]="isAllChecked"
                        [indeterminate]="isIndeterminate">
                    </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()"
                        (change)="$event ? formDataChecked(row) : null"
                        [checked]="selection.isSelected(row.requestNo)">
                    </mat-checkbox>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="selectProcessed">
                <mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ?
                        masterToggle($event.checked) : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() &&
                        !isAllSelected()">
                    </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <mat-checkbox *ngIf="row.statusAdmin === 'Sent To Foundation
                        Trustee'" (click)="$event.stopPropagation()"
                        (change)="$event ? formDataChecked(row) : null"
                        [checked]="selection.isSelected(row.requestNo)">
                    </mat-checkbox>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="requestNo">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header> Form Type </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row">
                    {{row.requestNo}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="formName">
                <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef
                    mat-sort-header> Request Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 3;" *matCellDef="let row">
                    {{row.formName}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="orgInfoName">
                <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef
                    mat-sort-header> Organization Name
                </mat-header-cell>
                <mat-cell style="flex-grow: 3;" *matCellDef="let row">
                    {{row.orgInfoName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="subsection">
                <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef
                    mat-sort-header> Tax-Exempt Status
                </mat-header-cell>
                <mat-cell style="flex-grow: 1;" *matCellDef="let row">
                    {{getTaxExemptStatus(row.orgInfoSubsection)}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dateRequest">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header>Request Date</mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row">
                    {{row.dateRequest | date: 'MM-dd-yyyy'}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="dateApproved">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header>Approved Date</mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row">
                    {{row.dateApproved | date: 'MM-dd-yyyy'}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="paymentOption">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header> Payment Option
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row">
                    {{row.paymentOption}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="totalAmount">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header> Total Amount
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> $
                    {{row.totalAmount}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef
                    mat-sort-header> Status </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"
                    [ngClass]="getStatusClass(row.statusAdmin)">
                    {{row.statusAdmin}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="confirm">
                <mat-header-cell style="flex-grow: 3;" style="align-content:
                    center" *matHeaderCellDef> Confirmation No / Control Report</mat-header-cell>
                <mat-cell style="flex-grow: 3;" style="align-content: center"
                    *matCellDef="let row">
                    {{row.paymentOption === 'CREDIT' && tableType ===
                    'processed'? row.confirmationNoCC :''}}
                    <button *ngIf="tableType === 'processed' && row.filePath !==
                        null" mat-icon-button matTooltip="Control Report"
                        (click)="onControlReport(row)">
                        <mat-icon color="primary">assignment</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
                <mat-header-cell style="flex-grow: 1;" style="align-content:
                    center" *matHeaderCellDef mat-sort-header></mat-header-cell>
                <mat-cell style="flex-grow: 1;"style="align-content: center"
                    *matCellDef="let row">
                    <!-- <button *ngIf="row.paymentOption === 'CHECK' && tableType === 'processed'" mat-icon-button matTooltip="Control Report" (click)="onControlReport(row)"> 
                        <mat-icon color="primary">assignment</mat-icon>
                    </button> -->
                    <!-- <button *ngIf="row.paymentOption === 'CREDIT' && tableType === 'processed'"  mat-icon-button matTooltip="Credit Card Payment" (click)="payAsCreditCard(row)"> 
                        <mat-icon color="primary">payment</mat-icon>
                    </button> -->
                    <button mat-icon-button matTooltip="Save application as PDF"
                        matTooltipShowDelay="200" (click)="onPrint(row)">
                        <mat-icon>save_alt</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="View"
                        matTooltipShowDelay="200" (click)="onView(row)">
                        <mat-icon color="primary">folder_open</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>
    </div>
    <div fxLayout="column">
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
</div>